export default __webpack_public_path__ + "static/media/azimuth.1ee81735.svg";